import React, { useEffect, useState } from 'react'

import { backdrop, container, containerOpen, modal } from './Modal.module.css'

const CLOSING_TIME = 500 // Same as in CSS animation

const Modal = ({ children, className, isOpen, onClose }) => {
  const [rendered, setRendered] = useState(false)
  const [open, setOpen] = useState(false)

  useEffect(() => {
    if (isOpen) {
      setRendered(true)

      const timeout = setTimeout(() => {
        setOpen(true)
      }, 50)

      return () => clearTimeout(timeout)
    }

    setOpen(false)

    const timeout = setTimeout(() => {
      setRendered(false)
    }, CLOSING_TIME)

    return () => clearTimeout(timeout)
  }, [isOpen])

  return rendered ? (
    <div className={`${container} ${open ? containerOpen : ''}`}>
      <div className={`${modal} ${className}`}>
        <div className={backdrop} onClick={onClose} role="presentation" />
        {children}
      </div>
    </div>
  ) : null
}

export default Modal
